__turbopack_context__.v({
  "className": "noto_sans_4b685017-module__YWxhpG__className",
});
